import { FC, PropsWithChildren } from "react";
import { GameDraggableId, GameDroppableId } from "../../../Games";
import { GameDraggable } from "../../../components/GameDraggable";
import { GameDroppable } from "../../../components/GameDroppable";

interface IFillGameDroppableProps extends PropsWithChildren {
  id: GameDroppableId | string;
  want: (GameDraggableId | "")[];
  have: GameDraggableId | "";
  disabled: boolean;
}

export const FillGameDroppable: FC<IFillGameDroppableProps> = ({
  children,
  id,
  want,
  have,
  disabled,
}) => {
  return (
    <GameDroppable id={id} want={want ?? []}>
      {have ? (
        <GameDraggable id={have} hostedBy={id} disabled={disabled}>
          {children}
        </GameDraggable>
      ) : (
        <></>
      )}
    </GameDroppable>
  );
};
